import '../../../scss/common/components/qpig.scss'

import {
  Body2,
  Grid,
  GridItem,
  Label2,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from '@sainsburys-tech/fable'
import React from 'react'

import { IAdditionalInformation } from '../../types/IAdditionalInformation'
import {
  getColumnText,
  getRowIdentifier,
  getValueFromField,
  hasTableFormatData,
} from './QpigUtils'

interface IQpigProcessStepsTableProps {
  additionalInformationList: IAdditionalInformation[]
}

const QpigProcessStepsTable = ({
  additionalInformationList,
}: IQpigProcessStepsTableProps) => {
  const getQpigTable = (isResponsive: boolean) => {
    if (!hasTableFormatData(additionalInformationList)) {
      return
    }

    const rows: string[][] = []
    const rawRows: string[] = []

    const getRows = () => {
      const columns: string[] = []
      additionalInformationList
        .filter((additionalInfo) => hasTableFormatData([additionalInfo]))
        .sort((a: IAdditionalInformation, b: IAdditionalInformation) =>
          getRowIdentifier(a) < getRowIdentifier(b) ? -1 : 1,
        )
        .forEach((additionalInfo, row) => {
          const fields = getColumnText(additionalInfo.description).split(',')
          fields.forEach((field) => {
            const isolatedColumnName = field
              .substring(0, field.indexOf(':'))
              .trim()
            const isolatedColumnValue = getValueFromField(field)
            const matchedColumn = columns.find((c) => c === isolatedColumnName)
            if (matchedColumn === undefined) {
              columns.push(isolatedColumnName)
            }
            if (rows.length < row + 1) {
              rows.push([])
              rawRows.push(additionalInfo.description)
            }
            rows[row].push(isolatedColumnValue)
          })
        })

      const tableColSpan = () => {
        switch (columns.length) {
          case 1:
            return 3
          case 2:
            return 6
          case 3:
            return 8
          default:
            return 12
        }
      }

      return (
        <div style={{ marginTop: '1rem' }}>
          <Grid data-testid='grid'>
            <GridItem colSpan={tableColSpan()}>
              <div className='c-qpig-table-fixed-width'>
                <Table className='c-qpig-border-line'>
                  <TableHeader>
                    <TableRow
                      data-testid={
                        isResponsive ? 'process-steps-header-row' : ''
                      }
                    >
                      {columns.map((column, colNumber) => (
                        <TableCell key={colNumber}>
                          <Label2>{column}</Label2>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {rows.map((row, rowNumber) => {
                      if (columns.length !== row.length) {
                        return (
                          <TableRow
                            data-testid={
                              isResponsive
                                ? `process-steps-row-${rowNumber}`
                                : ''
                            }
                            key={rowNumber}
                          >
                            <TableCell key={`${rowNumber}`}>
                              {rawRows[rowNumber]}
                            </TableCell>
                          </TableRow>
                        )
                      }
                      return (
                        <TableRow
                          data-testid={
                            isResponsive ? `process-steps-row-${rowNumber}` : ''
                          }
                          key={rowNumber}
                        >
                          {row.map((cell, cellNumber) => (
                            <TableCell
                              aria-label={columns[cellNumber]}
                              key={`${rowNumber}_${cellNumber}`}
                            >
                              <Body2>{cell}</Body2>
                            </TableCell>
                          ))}
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </div>
            </GridItem>
          </Grid>
        </div>
      )
    }

    return getRows()
  }

  return (
    <div className='c-table-responsive'>
      <div className='c-table-responsive__mobile c-qpig-table-margin'>
        {getQpigTable(true)}
      </div>
      <div className='c-table-responsive__desktop c-qpig-table-margin'>
        {getQpigTable(false)}
      </div>
    </div>
  )
}

export default QpigProcessStepsTable
